export interface EligibilityRowDraft {
  draftId: string;
  subject_id: string;
  grade_ref: string;
  section_id: string;
  is_class_teacher: boolean;
  preferred: boolean;
  max_periods_per_week_for_this_combo: string;
}

let _eligibilityDraftIdSeq = 0;

export function newEligibilityDraft(initial?: Partial<EligibilityRowDraft>): EligibilityRowDraft {
  _eligibilityDraftIdSeq += 1;
  return {
    draftId: `elig-${_eligibilityDraftIdSeq}`,
    subject_id: "",
    grade_ref: "",
    section_id: "",
    is_class_teacher: false,
    preferred: false,
    max_periods_per_week_for_this_combo: "",
    ...initial,
  };
}

export function isEligibilityRowFilled(row: EligibilityRowDraft): boolean {
  return Boolean(row.subject_id) && Boolean(row.grade_ref);
}

export function isEligibilityRowValid(row: EligibilityRowDraft): boolean {
  if (!isEligibilityRowFilled(row)) return false;
  if (row.is_class_teacher && !row.section_id) return false;
  if (row.max_periods_per_week_for_this_combo) {
    const n = Number(row.max_periods_per_week_for_this_combo);
    if (!Number.isFinite(n) || n < 0 || n > 60) return false;
  }
  return true;
}

/**
 * Project the editor's draft state onto the wire shape the BE expects.
 * Empty rows (no subject) are silently dropped — the "Add a subject"
 * empty state IS one of those rows, so we'd otherwise send a 422-bound
 * row to the server on every preview.
 */
export function eligibilityDraftsToPayload(rows: EligibilityRowDraft[]) {
  return rows.filter(isEligibilityRowValid).map((row) => {
    const maxPeriods = row.max_periods_per_week_for_this_combo
      ? Number(row.max_periods_per_week_for_this_combo)
      : null;
    return {
      subject_id: row.subject_id,
      grade_ref: row.grade_ref.trim(),
      section_id: row.section_id || null,
      is_class_teacher: row.is_class_teacher,
      preferred: row.preferred,
      max_periods_per_week_for_this_combo:
        maxPeriods !== null && Number.isFinite(maxPeriods) ? maxPeriods : null,
    };
  });
}
